/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Get_PremiumInputs */

const en_plan_get_premium = /** @type {(inputs: Plan_Get_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Premium`)
};

const es_plan_get_premium = /** @type {(inputs: Plan_Get_PremiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtener Premium`)
};

/**
* | output |
* | --- |
* | "Get Premium" |
*
* @param {Plan_Get_PremiumInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_get_premium = /** @type {((inputs?: Plan_Get_PremiumInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Get_PremiumInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_get_premium(inputs)
	return en_plan_get_premium(inputs)
});